import { __assign, __extends } from "tslib";
import * as React from 'react';
import { translate } from 'react-i18next';
import ListItem from '../common/ListItem';
import AddItem from '../common/AddItem';
import * as css from './ManageLabels.scss';
import DeleteLabelModal from './DeleteLabelModal';
import { Modal, MessageBoxFunctionalLayout } from 'wix-style-react';
var newLabel = { id: '', name: '' };
var ManageLabels = /** @class */ (function (_super) {
    __extends(ManageLabels, _super);
    function ManageLabels() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isAddLabelOpen: false,
            editedLabelId: null,
            labelToDelete: null,
            isDeleteLabelModalOpen: false,
            listContainerRef: null,
        };
        return _this;
    }
    ManageLabels.prototype.handleAddLabel = function (name) {
        this.props.onCreate(name);
        this.setState({ isAddLabelOpen: false });
    };
    ManageLabels.prototype.handleCancelAddLabel = function () {
        this.setState({ isAddLabelOpen: false });
    };
    ManageLabels.prototype.handleStartEdit = function (label) {
        this.props.onUpdateClick();
        this.setState({ editedLabelId: label.id });
    };
    ManageLabels.prototype.handleStartCreate = function () {
        this.props.onCreateClick();
        this.setState({ isAddLabelOpen: true });
    };
    ManageLabels.prototype.handleUpdate = function (label, name) {
        this.props.onUpdateConfirm(__assign(__assign({}, label), { name: name }));
        this.setState({ editedLabelId: null });
    };
    ManageLabels.prototype.handleCancelEdit = function () {
        this.setState({ editedLabelId: null });
    };
    ManageLabels.prototype.handleDeleteLabel = function (labelToDelete) {
        this.props.onDeleteClick();
        this.setState({ isDeleteLabelModalOpen: true, labelToDelete: labelToDelete });
    };
    ManageLabels.prototype.handleCloseDeleteLabelModal = function () {
        this.setState({ isDeleteLabelModalOpen: false });
    };
    ManageLabels.prototype.handleConfirmDeleteLabelModal = function () {
        this.props.onDeleteConfirm(this.state.labelToDelete);
        this.setState({ isDeleteLabelModalOpen: false, labelToDelete: null });
    };
    ManageLabels.prototype.render = function () {
        var _this = this;
        var _a = this.props, t = _a.t, isOpen = _a.isOpen, onClose = _a.onClose, labels = _a.labels, validateUniqueLabel = _a.validateUniqueLabel;
        var _b = this.state, isAddLabelOpen = _b.isAddLabelOpen, editedLabelId = _b.editedLabelId, isDeleteLabelModalOpen = _b.isDeleteLabelModalOpen, listContainerRef = _b.listContainerRef;
        return (React.createElement(Modal, { isOpen: isOpen, onRequestClose: onClose },
            React.createElement(MessageBoxFunctionalLayout, { confirmText: t('labelManagerDone'), buttonsHeight: "medium", onOk: onClose, onClose: onClose, title: t('manageLabels'), width: "583px", dataHook: "manage-labels-box", disableConfirmation: isAddLabelOpen || !!editedLabelId },
                React.createElement("div", { className: css.noticesWrapper },
                    React.createElement("div", { "data-hook": "notice1" }, t('labelManagerNotice1')),
                    React.createElement("div", { "data-hook": "notice2" }, t('labelManagerNotice2'))),
                React.createElement("div", { className: css.labelsWrapper, ref: function (el) {
                        if ((el && !listContainerRef) ||
                            (el && el.clientWidth !== listContainerRef.clientWidth)) {
                            _this.setState({ listContainerRef: el });
                        }
                    } }, labels.map(function (label, i) { return (React.createElement(ListItem, { key: label.id, dataHook: "label" + i, name: label.name, mode: label.id === editedLabelId ? 'edit' : 'view', onUpdate: function (name) { return _this.handleUpdate(label, name); }, onDelete: function () { return _this.handleDeleteLabel(label); }, onStartEdit: function () { return _this.handleStartEdit(label); }, onCancelEdit: function () { return _this.handleCancelEdit(); }, validateUniqueItem: validateUniqueLabel, deleteTooltipText: t('itemDeleteButtonTooltip'), renameTooltipText: t('itemRenameButtonTooltip'), alreadyExistsText: function (name) { return t('labelExists', { name: name }); } })); })),
                React.createElement("div", { style: {
                        width: listContainerRef && listContainerRef.clientWidth,
                        visibility: !listContainerRef ? 'hidden' : 'visible',
                    } }, isAddLabelOpen ? (React.createElement(ListItem, { dataHook: "new-label", name: newLabel.name, mode: "edit", onUpdate: function (name) { return _this.handleAddLabel(name); }, onCancelEdit: function () { return _this.handleCancelAddLabel(); }, validateUniqueItem: validateUniqueLabel, deleteTooltipText: t('itemDeleteButtonTooltip'), renameTooltipText: t('itemRenameButtonTooltip'), alreadyExistsText: function (labelName) { return t('labelExists', { labelName: labelName }); } })) : (React.createElement(AddItem, { dataHook: "add-label", onClick: function () { return _this.handleStartCreate(); } }, t('labelManagerAddLabel')))),
                React.createElement(DeleteLabelModal, { dataHook: "delete-label-modal", isOpen: isDeleteLabelModalOpen, onClose: function () { return _this.handleCloseDeleteLabelModal(); }, onConfirm: function () { return _this.handleConfirmDeleteLabelModal(); } }))));
    };
    return ManageLabels;
}(React.PureComponent));
export default translate()(ManageLabels);
//# sourceMappingURL=ManageLabels.js.map